module.exports = __webpack_public_path__ + "newstatic/media/2.0d00e39.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video/2.mp4
// module id = sPDg
// module chunks = 1